import { __spreadArray } from "tslib";
import { ClassicGameId } from './enums/ClassicGameId';
import { TwainGameId } from './enums/TwainGameId';
// https://confluence.betgames.tv/display/DEV2/Game+features+contract
var GameDefinition = /** @class */ (function () {
    function GameDefinition() {
    }
    GameDefinition.isClassic = function (gameId) {
        return this.CLASSIC_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isShow = function (gameId) {
        return this.SHOW_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isTwain = function (gameId) {
        return this.TWAIN_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithStaticOdds = function (gameId) {
        return this.STATIC_ODDS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithDynamicOdds = function (gameId) {
        return this.DYNAMIC_ODDS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithCombinationOdds = function (gameId) {
        return this.COMBINATIONS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithSubscriptionOdds = function (gameId) {
        return this.SUBSCRIPTIONS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithRandomOdds = function (gameId) {
        return this.RANDOM_ODDS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithPickXOdds = function (gameId) {
        return this.PICK_X_ODDS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isCard = function (gameId) {
        return this.CARDS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isLive = function (gameId) {
        return this.LIVE_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isRng = function (gameId) {
        return this.RNG_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isScheduled = function (gameId) {
        return this.SCHEDULED_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isGui = function (gameId) {
        return this.GUI_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithRounds = function (gameId) {
        return this.ROUNDS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isWithRepeatBets = function (gameId) {
        return this.REPEAT_BETS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isRoulette = function (gameId) {
        return this.ROULETTE_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isSkywardGame = function (gameId) {
        return this.SKYWARD_GAMES_IDS.includes(gameId);
    };
    /**
     * @description Games provided by ProxyLiveSolutions partner
     */
    GameDefinition.isPLSGame = function (gameId) {
        return this.PLS_GAMES_IDS.includes(gameId);
    };
    GameDefinition.isSlotGame = function (gameId) {
        return this.SLOT_GAMES_IDS.includes(gameId);
    };
    /**
     * @description Games provided by Hinterzimmer partner
     */
    GameDefinition.isHZGame = function (gameId) {
        return this.HZ_GAMES_IDS.includes(gameId);
    };
    var _a;
    _a = GameDefinition;
    GameDefinition.CLASSIC_GAMES_IDS = Object.keys(ClassicGameId)
        .filter(function (id) { return !isNaN(Number(id)); })
        .map(Number);
    GameDefinition.TWAIN_GAMES_IDS = Object.keys(TwainGameId)
        .filter(function (id) { return !isNaN(Number(id)); })
        .map(Number);
    GameDefinition.SHOW_GAMES_IDS = [ClassicGameId.STARZLE, ClassicGameId.GIZA];
    GameDefinition.STATIC_ODDS_GAMES_IDS = [
        ClassicGameId.LUCKY7,
        ClassicGameId.LUCKY6,
        ClassicGameId.LUCKY5,
        ClassicGameId.DICE_DUEL,
        ClassicGameId.WHEEL,
        ClassicGameId.RNG_WHEEL,
        ClassicGameId.RNG_FOOTBALL_GRID,
        ClassicGameId.BETWAY_LUCKY7,
        ClassicGameId.RNG_ROULETTE,
        ClassicGameId.LUCKY_KICKS,
    ];
    GameDefinition.DYNAMIC_ODDS_GAMES_IDS = [
        ClassicGameId.POKER,
        ClassicGameId.BACCARAT,
        ClassicGameId.WAR,
        ClassicGameId.SIX_PLUS_POKER,
        ClassicGameId.STS_POKER,
        ClassicGameId.SKYWARD,
        ClassicGameId.SKYWARD_GLS,
        ClassicGameId.SKYWARD_100,
    ];
    GameDefinition.PICK_X_ODDS_GAMES_IDS = [
        ClassicGameId.RNG_LUCKY7,
        ClassicGameId.STARZLE,
    ];
    GameDefinition.CARDS_GAMES_IDS = [
        ClassicGameId.POKER,
        ClassicGameId.BACCARAT,
        ClassicGameId.WAR,
        ClassicGameId.SIX_PLUS_POKER,
        ClassicGameId.STS_POKER,
    ];
    GameDefinition.LIVE_GAMES_IDS = [
        ClassicGameId.POKER,
        ClassicGameId.BACCARAT,
        ClassicGameId.WAR,
        ClassicGameId.SIX_PLUS_POKER,
        ClassicGameId.STS_POKER,
        ClassicGameId.DICE_DUEL,
        ClassicGameId.WHEEL,
        ClassicGameId.STARZLE,
        ClassicGameId.GIZA,
    ];
    GameDefinition.RNG_GAMES_IDS = [
        ClassicGameId.RNG_WHEEL,
        ClassicGameId.RNG_FOOTBALL_GRID,
        ClassicGameId.RNG_LUCKY7,
        ClassicGameId.RNG_ROULETTE,
        ClassicGameId.LUCKY_KICKS,
        ClassicGameId.RGS_ROULETTE_EURO,
        ClassicGameId.LUCKY_LENNY,
        TwainGameId.RNG_T_KICK,
        TwainGameId.RNG_B_RING,
    ];
    GameDefinition.SKYWARD_GAMES_IDS = [
        ClassicGameId.SKYWARD,
        ClassicGameId.SKYWARD_GLS,
        ClassicGameId.SKYWARD_CAP,
        ClassicGameId.SKYWARD_DELUXE,
        ClassicGameId.SKYWARD_100,
    ];
    GameDefinition.SCHEDULED_GAMES_IDS = __spreadArray([
        ClassicGameId.LUCKY7,
        ClassicGameId.LUCKY6,
        ClassicGameId.LUCKY5,
        ClassicGameId.BETWAY_LUCKY7,
        ClassicGameId.RNG_LUCKY7
    ], GameDefinition.SKYWARD_GAMES_IDS, true);
    GameDefinition.GUI_GAMES_IDS = __spreadArray([
        ClassicGameId.RNG_LUCKY7,
        ClassicGameId.RGS_ROULETTE_EURO,
        ClassicGameId.LUCKY_LENNY
    ], GameDefinition.SKYWARD_GAMES_IDS, true);
    GameDefinition.ROUNDS_GAMES_IDS = [
        ClassicGameId.POKER,
        ClassicGameId.BACCARAT,
        ClassicGameId.WAR,
        ClassicGameId.SIX_PLUS_POKER,
        ClassicGameId.STS_POKER,
        ClassicGameId.STARZLE,
        ClassicGameId.GIZA,
    ];
    GameDefinition.COMBINATIONS_GAMES_IDS = [
        ClassicGameId.LUCKY7,
        ClassicGameId.LUCKY5,
        ClassicGameId.LUCKY6,
        ClassicGameId.DICE_DUEL,
        ClassicGameId.WHEEL,
        ClassicGameId.BETWAY_LUCKY7,
    ];
    GameDefinition.SUBSCRIPTIONS_GAMES_IDS = [
        ClassicGameId.LUCKY7,
        ClassicGameId.LUCKY5,
        ClassicGameId.LUCKY6,
        ClassicGameId.BETWAY_LUCKY7,
        ClassicGameId.RNG_LUCKY7,
    ];
    GameDefinition.RANDOM_ODDS_GAMES_IDS = [
        ClassicGameId.LUCKY5,
        ClassicGameId.LUCKY6,
        ClassicGameId.LUCKY7,
        ClassicGameId.DICE_DUEL,
        ClassicGameId.RNG_FOOTBALL_GRID,
        ClassicGameId.WHEEL,
        ClassicGameId.RNG_WHEEL,
        ClassicGameId.BETWAY_LUCKY7,
        ClassicGameId.RNG_LUCKY7,
        ClassicGameId.LUCKY_KICKS,
    ];
    GameDefinition.REPEAT_BETS_GAMES_IDS = [
        ClassicGameId.LUCKY5,
        ClassicGameId.LUCKY6,
        ClassicGameId.LUCKY7,
        ClassicGameId.DICE_DUEL,
        ClassicGameId.RNG_FOOTBALL_GRID,
        ClassicGameId.WHEEL,
        ClassicGameId.RNG_WHEEL,
        ClassicGameId.BETWAY_LUCKY7,
        ClassicGameId.RNG_LUCKY7,
        ClassicGameId.RNG_ROULETTE,
        ClassicGameId.LUCKY_KICKS,
        ClassicGameId.STARZLE,
        ClassicGameId.GIZA,
    ];
    GameDefinition.ROULETTE_GAMES_IDS = [
        ClassicGameId.ROULETTE_EURO_GE,
        ClassicGameId.ROULETTE_EURO_LT,
        ClassicGameId.ROULETTE_AMERICAN_GE,
        ClassicGameId.ROULETTE_FLASH_LT,
        ClassicGameId.RNG_ROULETTE,
        ClassicGameId.RGS_ROULETTE_EURO,
    ];
    GameDefinition.PLS_GAMES_IDS = [
        ClassicGameId.PLS_BLACKJACK_T1,
        ClassicGameId.PLS_BLACKJACK_T2,
        ClassicGameId.PLS_BLACKJACK_T3,
        ClassicGameId.PLS_BLACKJACK_T4,
        ClassicGameId.PLS_BLACKJACK_T5,
        ClassicGameId.PLS_BLACKJACK_T6,
        ClassicGameId.PLS_BLACKJACK_T7,
        ClassicGameId.PLS_BLACKJACK_T8,
        ClassicGameId.PLS_BLACKJACK_T9,
        ClassicGameId.PLS_BLACKJACK_T10,
        ClassicGameId.PLS_BLACKJACK_T11,
        ClassicGameId.PLS_BLACKJACK_T12,
        ClassicGameId.PLS_BLACKJACK_T13,
        ClassicGameId.PLS_BLACKJACK_T14,
        ClassicGameId.PLS_BLACKJACK_T15,
    ];
    GameDefinition.SLOT_GAMES_IDS = [
        ClassicGameId.CITRUS_SPLASH,
        ClassicGameId.CANDY_COINS,
        ClassicGameId.LOTUS_WEALTH_WONDERS,
        ClassicGameId.GIZA_SLOT,
        ClassicGameId.GIZA_SLOT_RTP_94,
        ClassicGameId.GIZA_SLOT_RTP_96,
        ClassicGameId.CITRUS_SPLASH_HWB,
        ClassicGameId.CITRUS_SPLASH_BETWAY,
        ClassicGameId.CANDY_COINS_HWB,
        ClassicGameId.CANDY_COINS_BETWAY,
        ClassicGameId.CANDY_COINS_SUNBET,
        ClassicGameId.LOTUS_WEALTH_WONDERS_HWB,
        ClassicGameId.LOTUS_WEALTH_WONDERS_BETWAY,
        ClassicGameId.GIZA_SLOT_BETWAY,
        ClassicGameId.GIZA_SLOT_OLIMP,
        ClassicGameId.BAD_BABOONS,
        ClassicGameId.BAD_BABOONS_RTP_94,
        ClassicGameId.BAD_BABOONS_RTP_96,
        ClassicGameId.BAD_BABOONS_BETWAY,
        ClassicGameId.BAD_BABOONS_DELUXE,
        ClassicGameId.BAD_BABOONS_DELUXE_RTP_94,
        ClassicGameId.BAD_BABOONS_DELUXE_RTP_96,
        ClassicGameId.DRAGONS_FATE,
        ClassicGameId.DRAGONS_FATE_RTP_94,
        ClassicGameId.DRAGONS_FATE_RTP_96,
        ClassicGameId.LUCKY_LOKI,
        ClassicGameId.LUCKY_LOKI_RTP_94,
        ClassicGameId.LUCKY_LOKI_RTP_96,
        ClassicGameId.GIZA_SLOT_DELUXE,
        ClassicGameId.GIZA_SLOT_DELUXE_RTP_94,
        ClassicGameId.GIZA_SLOT_DELUXE_RTP_96,
        ClassicGameId.FOREST_FRENZY,
        ClassicGameId.FOREST_FRENZY_RTP_94,
        ClassicGameId.FOREST_FRENZY_RTP_96,
        ClassicGameId.LOTUS_WEALTH_WONDERS_DELUXE,
        ClassicGameId.LOTUS_WEALTH_WONDERS_DELUXE_RTP_94,
        ClassicGameId.LOTUS_WEALTH_WONDERS_DELUXE_RTP_96,
        ClassicGameId.GOLDEN_ADVENTURE,
        ClassicGameId.GOLDEN_ADVENTURE_RTP_94,
        ClassicGameId.GOLDEN_ADVENTURE_RTP_96,
        ClassicGameId.CITRUS_SPLASH_SUNBET,
        ClassicGameId.GIZA_SLOT_HWB,
        ClassicGameId.DRAGONS_FATE_ONE_WIN,
        ClassicGameId.BUFFALO_WILDS,
        ClassicGameId.BUFFALO_WILDS_RTP_94,
        ClassicGameId.BUFFALO_WILDS_RTP_96,
        ClassicGameId.OLYMPUS_GOLD,
        ClassicGameId.OLYMPUS_GOLD_RTP_94,
        ClassicGameId.OLYMPUS_GOLD_RTP_96,
        ClassicGameId.FRUIT_FIRE_7,
        ClassicGameId.FRUIT_FIRE_7_RTP_94,
        ClassicGameId.FRUIT_FIRE_7_RTP_96,
    ];
    GameDefinition.TAP_GAMES_IDS = [
        ClassicGameId.PENGUIN_RUSH,
        ClassicGameId.PENGUIN_RUSH_HWB,
        ClassicGameId.PENGUIN_RUSH_NEW_THEME,
        ClassicGameId.PENGUIN_RUSH_OLIMP_RED_RTP_96,
        ClassicGameId.PENGUIN_RUSH_ONE_WIN_RTP_96,
        ClassicGameId.PENGUIN_RUSH_SPORTPESA_RTP_96,
    ];
    GameDefinition.HZ_GAMES_IDS = __spreadArray(__spreadArray([], _a.SLOT_GAMES_IDS, true), _a.TAP_GAMES_IDS, true);
    return GameDefinition;
}());
export { GameDefinition };
